import styled from 'styled-components'
import { device } from '../Breakpoints'

export const Container = styled.section`
  background: linear-gradient(to top, #c3c4e8, #8e8fc7);
  box-sizing: border-box;
  margin: 1em 0;
  padding: 0 0 0 2em;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: top;
  width: 100%;
  @media ${device.mobileL} {
    flex-wrap: wrap;
    padding: 0 2em;
    margin: 1em 0;
  }
  h3 {
    max-width: 200px;
    width: 100%;
    margin-top: 2em;
    font-weight: normal;
    font-size: 1.1em;
    svg {
      vertical-align: middle;
      margin-left: 20px;
      @media ${device.mobileL} {
        margin: auto;
        display: block;
      }
    }
    @media ${device.mobileL} {
      max-width: 100%;
      text-align: center;
    }
  }
  ul {
    flex-grow: 1;
    padding: 0.5em 3em;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      /**
      Target IE11
      */
      width: 50% !important;
    }
    @media ${device.mobileL} {
      margin-top: 0;
      padding: 0.5em;
    }
    li {
      padding: 1em 0;
      list-style: none;
      border-bottom: 1px solid #ffffff;
      min-width: 48%;
      max-width: 48%;

      a {
        color: #ffffff;
        text-decoration: none;
        :hover {
          text-decoration: underline;
        }
      }
      p {
        color: #ffffff;
        font-family: 'Santral Light', Arial, Helvetica, sans-serif;
      }
      @media ${device.mobileL} {
        padding: 1em;
        width: 100%;
        max-width: 100%;
        :last-child {
          border: none;
        }
      }
      @media ${device.minTablet} {
        /**/
        :nth-last-child(-n + 1),
        :nth-last-child(2):nth-child(odd) {
          border: none;
        }
      }
    }
  }
`
export const AlignCenter = styled.div`
  order: 3;
  width: 100%;
  max-width: 1114px;
  margin: auto;
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    /**
      Target IE11
      */
    margin: 0 !important;
  }
  @media ${device.mobileL} {
    max-width: 100%;
    margin: auto;
  }
`
